import React from "react";
import { connect } from "react-redux";
import Component from "./component";
import { nextStep, setFormData, previousStep } from "../pickup-form.actions";

import { addDonor } from "api/users";
import Tracking from "utils/tracking";
import { showToastError } from "../../../helpers";

const mapStateToProps = (state, ownProps) => ({
  newDonorFormComplete: state.donorWizard.formValues.newDonorFormComplete,
  phoneNumber: state.donorWizard.formValues.phoneNumber,
});

const addDonorAction = (form) => {
  return (dispatch, getState) =>
    new Promise((resolve, reject) => {
      let state = getState();

      const { fname, lname, email, phoneNumber } = state.donorWizard.formValues;

      return addDonor({
        fname: fname,
        lname: lname,
        email: email,
        phoneNumbers: [{ number: phoneNumber }],
      })
        .then((user) => {
          Tracking.track("Step 5: New Donor Created");
          dispatch(setFormData({ user: user.data.data[0] }));
          // This is interesting because we get a token back from a no password user. This would allow us to create a local user with no password.
          // authenticateDonorComplete(user)
          if (state.donorWizard.formValues.skipRegistration) {
            Tracking.track("Step 5: Skip Registration");
            dispatch(setFormData({ newDonorFormComplete: true }));
            resolve();
          } else {
            Tracking.track("Step 5: New Donor Form Completed");
            dispatch(setFormData({ newDonorFormComplete: true }));
            resolve();
          }
        })
        .catch((err) => {
          dispatch(setFormData({ newDonorFormComplete: false }));
          reject();
          showToastError();
        });
    });
};

const submitNewDonorForm = (form) => {
  return (dispatch, getState) => {
    dispatch(setFormData({ ...form }));
    return dispatch(addDonorAction(form));
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onSubmit: (form) => dispatch(submitNewDonorForm(form)),
    previousStep: () => dispatch(previousStep()),
  };
};

// Connect to the store using a container component
const withConnect = connect(mapStateToProps, mapDispatchToProps)(Component);

export default withConnect;
